var map = {
	"./abbv-blue.svg": 1331,
	"./abbv-consent.svg": 1332,
	"./abbv-page.png": 613,
	"./abbv-white.svg": 1084,
	"./bayer-light.svg": 1083,
	"./bayer.svg": 1333,
	"./default.svg": 1334,
	"./navi.svg": 1335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1330;